import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UtilityService } from '../utility.service';
import { BaseFormService } from 'app/services/BaseFormService';
import { environment } from 'environments/environment';
import { CheckRequestView } from 'app/models/form/CheckRequestView';
import { FileUploadService } from '../file-upload-service';

@Injectable({
	providedIn: 'root',
})
export class CheckRequestServices extends BaseFormService {
	private showDuplicateInvoicePopup = new BehaviorSubject<boolean>(false);

	constructor(httpClient: HttpClient, utilityService: UtilityService, private fileUpload: FileUploadService) {
		super(`${environment.apiUrl}forms/clients/$$clientId$$/check-request`, httpClient, utilityService);
		this.setFileUploadService(fileUpload);
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<CheckRequestView> {
		return this.httpClient
			.post<CheckRequestView>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	convertToApinvoice(clientId: string, id: any, poNumber: string, userId): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/convert-form/${poNumber}`, {
				userId,
			})
			.pipe();
	}
	convertToQuickPay(clientId: string, id: any, userId): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/convert-quick-form/`, {
				userId,
			})
			.pipe();
	}

	getRecurringForms(clientId: string): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/recurring-forms`).pipe();
	}

	uploadFile(clientId: string, id, file: File): Observable<HttpEvent<any>> {
		const formData: FormData = new FormData();
		formData.append('file', file);
		const req = new HttpRequest('POST', `${this.getUrl(clientId)}/${id}/docs`, formData, {
			reportProgress: true,
			responseType: 'json',
		});
		return this.httpClient.request(req);
	}

	showDuplicateInvoicePopupChange$ = this.showDuplicateInvoicePopup.asObservable();
	setShowDuplicateInvoicePopup(value: boolean) {
		this.showDuplicateInvoicePopup.next(value);
	}

	convertInvoiceIntoCheckRequest(clientId: string, invoice: any) {
		const formData: FormData = new FormData();
		formData.append('SampleInvoice', invoice);
		return this.httpClient.post<any>(`${this.getUrl(clientId)}/convert-invoice-to-checkrequest`, formData).pipe();
	}
	delegateForm(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient.put<any>(`${this.getUrl(clientId)}/${id}/delegate/${userId}`, {}).pipe();
	}
	logBudgetToleranceWarning(
		clientId: string,
		id: any,
		payload: { budgetToleranceErrors: string[]; workflowStep?: string; triggerReason?: string }
	): Observable<any> {
		return this.httpClient.patch<any>(`${this.getUrl(clientId)}/${id}/budget-tolerance-warning`, payload).pipe();
	}
}
